import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <footer className="site-footer">
            <span>ГЕОКАРБОН · КЦ НГУ</span>
            <span>Новосибирск, ул. Пирогова, 2</span>
        </footer>
    );
};

export default Footer;
